import type { RateRepository } from '@/core/rate'
import type { UseCase } from '@/core/shared'

export const getRate: UseCase<RateRepository, 'getRate'> = repository => {
  return async (payload) => {
    return await repository.getRate(payload)
  }
}
